import { EventTypes, getPageSource, track } from '@mc/track-event'

/**
 * Track when users click the info icon on the Free gift membership matrix row.
 */
export const trackFreeGiftMembershipRowClick = () =>
  track(EventTypes.PLANS_PAGE_CLICK, {
    category: 'pricing matrix',
    action: 'free_gift_membership.tooltip',
    location: 'General',
  })

/**
 * Track when users click the support link inside the Free gift membership FAQ answer.
 */
export const trackFreeGiftMembershipFaqLinkClick = () =>
  track(EventTypes.PLANS_PAGE_CLICK, {
    category: 'faq',
    action: 'free_gift_membership.gift_support',
    location: 'General',
    page_path: window.location.pathname,
    page_source: getPageSource(),
  })
